import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SessionTimeout from "../../../hoc/SessionTimeout";
import WithRoutify from "../../../hoc/WithRoutify";
import Buttons from "../../UI/Buttons";
import KioskExitModal from "../../Modal/KioskExitModal";
import KioskIdleLockOverlay from "../../Kiosk/KioskIdleLockOverlay";
import {
  clearKioskSession,
  getKioskReturnPath,
  useKioskIdleTimer,
} from "../../../utils/patientFormKiosk";

/**
 * Restricted shell for kiosk patient forms — no staff nav; staff exits via PIN.
 * 15-minute kiosk idle lock is separate from REACT_APP_SESSION_TIMEOUT (staff login).
 */
function KioskPatientFormLayout({ children, Toast }) {
  const navigate = useNavigate();
  const reloadId = useSelector((state) => state.common.reloadKeyProps);
  const [showExitModal, setShowExitModal] = useState(false);
  const [isIdleLocked, setIsIdleLocked] = useState(false);

  const handleIdle = useCallback(() => {
    setIsIdleLocked(true);
  }, []);

  const { resetTimer } = useKioskIdleTimer({
    enabled: !isIdleLocked,
    onIdle: handleIdle,
  });

  const handleIdleUnlock = useCallback(() => {
    setIsIdleLocked(false);
    resetTimer();
    Toast?.success?.("Kiosk session resumed.");
  }, [resetTimer, Toast]);

  const handleExitSuccess = () => {
    setShowExitModal(false);
    const returnPath = getKioskReturnPath();
    clearKioskSession({ broadcastExitToOtherTabs: true, returnPath });
    navigate(returnPath, { replace: true });
    Toast?.success?.("Kiosk mode ended.");
  };

  return (
    <>
      <SessionTimeout timeout={process.env.REACT_APP_SESSION_TIMEOUT} />
      <KioskIdleLockOverlay
        isOpen={isIdleLocked}
        onUnlock={handleIdleUnlock}
        Toast={Toast}
      />
      <KioskExitModal
        isOpen={showExitModal}
        onClose={() => setShowExitModal(false)}
        onSuccess={handleExitSuccess}
        Toast={Toast}
      />
      <div>
        <div id="wrapper">
          <div id="content-wrapper" className="d-flex flex-column patient-content-wrap">
            <div id="content">
              {/* fixed-top + patient-top: matches PatientForm Header; sh_mainPortview margin-top: 75px clears this bar */}
              <nav className="navbar navbar-expand navbar-light topbar mb-0 fixed-top patient-top w-100 d-flex align-items-center justify-content-between px-3">
                <span className="font-weight-bold text-dark mb-0">Patient forms</span>
                <Buttons
                  clickHandler={() => setShowExitModal(true)}
                  className="btn btn-primary sh_btnprimary btn-sm text-sm"
                  acl="any"
                  label="Exit kiosk"
                  disabled={isIdleLocked}
                />
              </nav>
              <div className="container-fluid">
                <div className="sh_mainPortview" id="sh_mainportal_view">
                  <div className="sh_innerPortview" key={reloadId}>
                    {children}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WithRoutify(KioskPatientFormLayout);
